import { Anchor } from '@common';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskOpenContextActionPropsType = {
  to: string;
};

export const TaskOpenContextAction: React.FC<
  TaskOpenContextActionPropsType
> = ({ to }) => {
  const { t } = useTranslation('tasks');
  const label = t('ACTIONS.OPEN_CONTEXT');

  return (
    <Tooltip label={label}>
      <Anchor to={to} aria-label={label} c="inherit">
        <FontAwesomeIcon
          icon={faArrowRight}
          size="sm"
          color="var(--mantine-color-text-4)"
        />
      </Anchor>
    </Tooltip>
  );
};
